<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader @import-event="importFile" @export-event="exportFile" :renderImport="!isLoading" :renderExport="!isLoading" :isImporting="isImporting" :isExporting="isExporting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							
							<div class="row p-3">
								<div class="col-md-6">
									<Button class="p-button-sm" @click="add" label="Create New User"/>
								</div>
							</div>
							
							<div class="row p-3 pb-0">
								<label><b>Search existing User by:</b></label>
							</div>
							
							<div class="row p-3 pb-0">
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Name" v-model="filterNameModel.value" />
								</div>
								
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Email Address" v-model="filterEmailAddressModel.value" />
								</div>

								<div class="col-md-4">
										<Dropdown :options="companies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear :placeholder="isCompanyLoading ? ('Loading...') : 'Company'" :loading="isCompanyLoading" v-model="filterCompanyModel.value">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCompanyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCompanyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
								</div>
							</div>
							
							<div class="row p-3 pb-0">		
								<div class="col-md-4">
									<Dropdown :options="getUserStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="Status" v-model="filterStatusModel.value" />
								</div>
								
								<div class="col-md-4">
                                    <Dropdown :options="filterUserRoles" optionLabel="name" optionValue="value" placeholder="Role" v-model="filterUserRoleModel.value" display="chip" @change="resetCompanies" :disabled="!isAdmin && userRole == 'Admin'"/>
                                </div>				
							</div>
							
							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search"/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset"/>
								</div>
									
								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 8%;">#</th>
												<th style="width: 25%; cursor: pointer;" @click="sort('x.employee.name')">Name <span class="pi" :class="[sortingModel.columnName == 'x.employee.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 25%; cursor: pointer;" @click="sort('x.employee.emailAddress')">Email Address <span class="pi" :class="[sortingModel.columnName == 'x.employee.emailAddress' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 25%;">Role </th>
												<th style="width: 12%;">Status</th>
												<th style="width: 5%;"></th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(user, index) in pagination.users" :key="index">
												<td v-on:click="view(user)">{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
												<td v-on:click="view(user)">{{user.name}}</td>
												<td v-on:click="view(user)">{{user.emailAddress}}</td>
												<td v-on:click="view(user)">{{user.userRoles}}</td>
												<td>
													<div class="d-flex align-items-center">
														<Badge class="mr-2" :class="[user.status == 'Active' ? 'p-badge-success' : 'p-badge-danger']" :value="user.status"></Badge>
													</div>
												</td>
												<td>
													<Button icon="pi pi-unlock text-danger" title="Unlock Account" severity="danger" text rounded  @click="unlock(user.identifier)" v-if="user.failedLoginCount >= 3"/>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								
								<div class="error-no-record" v-if="!isLoading && pagination.users.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>
								
								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>

						<TheInvalidImportDialog title="Employee" :visible="isDialogVisible" :data="invalidData" @close-dialog-event="closeDialog" @proceed-import-event="proceedImport"></TheInvalidImportDialog>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import {useRoute} from "vue-router"
	import store from "@/store";
	import userApi from "@/api/user-api";
	import companyApi from "@/api/company-api";
	import statusMixin from "@/mixin/status";
	import roleMixin from "@/mixin/role";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheInvalidImportDialog from "@/components/TheInvalidImportDialog.vue";
	
	export default defineComponent({
		mixins: [statusMixin, roleMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			ThePageError,
			TheInvalidImportDialog
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				user: {username: '', password: '', employee: {identifier: '', name: '', emailAddress: '', mobilePhone: '', employeeCompanies: [] as any[], employeeEmailCompanies: [] as any[], isClosed: false}, userRoles: [] as any[], isClosed: false},
				companies: [] as any[],
				userRole: null as any,
				company: null as any,
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, users: [], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.employee.name", isAscending: true} : store.getters.getCached.page.sortingModel),
				filterNameModel:(store.getters.getCached.page == null ?  {value: ""} : store.getters.getCached.page.filterNameModel),
				filterEmailAddressModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterEmailAddressModel),
				filterCompanyModel:(store.getters.getCached.page == null ?  {value: null} : store.getters.getCached.page.filterCompanyModel),
				filterStatusModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterStatusModel),
				filterUserRoleModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterUserRoleModel),
				isLoading: false,
				isCompanyLoading: false,
				isImporting: false,
				isExporting: false,
				isDialogVisible: false,
				invalidData: {} as any
			}
		},
		watch: {
			filterLegalGroupId(newValue: any) {
				this.loadCompanyList();
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.find(this.pagination.currentPage);
				
				this.loadCompanyList();
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			},
			filterLegalGroupId() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
			},
			filterUserRoles() {
				if (this.isHQStaff && this.identifier == null) {
					this.roles.forEach((role: any, index: any) => {
						if (role.value == 'Admin') {
							this.roles.splice(index, 1);
						}
					})
					return this.roles;
				}
				return this.roles;
			}
		},
		methods: {
			loadCompanyList() {
				this.filterCompanyModel = {value: null};
						
				this.isCompanyLoading = true;
				companyApi.companyList({}, this.filterLegalGroupId)
					.then(response => {
						this.companies = response.data.listSet;
						this.isCompanyLoading = false;
					})
					.catch(error => {
						this.isCompanyLoading = false;
					});
			},
			filterCompanyCodeByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].code;
				}
				return null;
			},
			filterCompanyNameByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].name;
				}
				return null;
			},
			resetCompanies() {
				if (this.userRole != 'RPK User') {
					this.user.employee.employeeCompanies = [];
				}
				this.company = null;
			},
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;
				
				store.getters.getCached.page = {
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterNameModel: JSON.parse(JSON.stringify(this.filterNameModel)),
					filterEmailAddressModel: JSON.parse(JSON.stringify(this.filterEmailAddressModel)),
					filterCompanyModel: JSON.parse(JSON.stringify(this.filterCompanyModel)),
					filterStatusModel: JSON.parse(JSON.stringify(this.filterStatusModel)),
					filterUserRoleModel: JSON.parse(JSON.stringify(this.filterUserRoleModel))
				};
				
				userApi.userFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterNameModel: this.filterNameModel,
						filterEmailAddressModel: this.filterEmailAddressModel,
						filterCompanyModel: this.filterCompanyModel,
						filterStatusModel: this.filterStatusModel,
						filterUserRoleModel: this.filterUserRoleModel
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, users: response.data.rowSet, totalItems: response.data.totalItems}
						if (store.getters.getCached.page == null) {
							store.getters.getCached.page = {};
						}
						store.getters.getCached.page.pagination = this.pagination;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, users: [], totalItems: 0};
				this.sortingModel = {columnName: "x.employee.name", isAscending: true};
				this.filterNameModel = {value: ""};
				this.filterEmailAddressModel = {value: ""};
				this.filterCompanyModel = {value: ""};
				this.filterStatusModel = {value: null};
				this.filterUserRoleModel = {value: null};
				this.find(1);
			},
			add() {
				this.$router.push("/admin/user/add");
			},
			view(user: any) {
				this.$router.push("/admin/user/view/" + user.identifier);
			},
			unlock(identifier: string) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to unlock this user account?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						userApi.userUnlock({
							user: {
								identifier: identifier
							}
						})
						.then((response: any) => {
							this.isLoading = false;
							this.$toast.add({severity: 'success', summary: 'Success', detail: response.message, life: 6000});
							
							this.user = response.data.user;
							
							// const idx = this.pagination.users.findIndex((u: any) => u.identifier == this.user.employee.identifier);
							// this.pagination.users[idx].failedLoginCount = 0;

							if (this.user.userRoles != null && this.user.userRoles.length == 1) {
								this.userRole = this.user.userRoles[0].role;
							}
							this.$router.go(0);
						})
						.catch((error) => {
							this.isLoading = false;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						})
					}
				});
			},
			importFile(file: any) {
				this.isImporting = true;

				var formData = new FormData();
				formData.append('file', file[0]);
				
				userApi.userImport(formData)
					.then((response: any) => {
						this.isImporting = false;
						this.invalidData = response.data;
						this.isDialogVisible = true;
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			proceedImport(isOverride: boolean) {
				this.isImporting = true;

				let tempInvalidData = JSON.parse(JSON.stringify(this.invalidData));
				
				if (isOverride == false && tempInvalidData.warningCount > 0) {
					tempInvalidData.invalidRows.forEach((invalidRow: any, index: any) => {
						if (invalidRow.type == "Warning") {
							invalidRow.type = "Error";
							return invalidRow;
						}
					});
				}

				userApi.userImportProceed({'invalidData': tempInvalidData})
					.then((response: any) => {
						this.isImporting = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.isDialogVisible = false;
						this.find(1);
					})
					.catch(error => {
						this.isImporting = false;
						this.isDialogVisible = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})				
			},
			exportFile() {
				this.isExporting = true;

				userApi.userExport({
						filterNameModel: this.filterNameModel,
						filterEmailAddressModel: this.filterEmailAddressModel,
						filterCompanyModel: this.filterCompanyModel,
						filterStatusModel: this.filterStatusModel,
						filterUserRoleModel: this.filterUserRoleModel
					})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			closeDialog() {
				this.isDialogVisible = false;
			}
		}
	});
</script>
